import React from "react";
import "./Css/Footer.css";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import logo from "./Ellipse 2 (1).png"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left Side */}
        <div className="footer-left">
          <img
            src={logo}
            alt="AK Logo"
            className="logo"
          />
          <h2 className="brand-name">AKES Software</h2>
          <p>© 2026 AKES Software</p>

          <a
            href="https://wa.me/919423923904"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            <FaWhatsapp className="whatsapp-icon" />
          </a>
        </div>

        <div className="footer-right">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/termsconditions">Terms & Conditions</Link>
          <Link to="/refundpolicy">Refund Policy</Link>
          <Link to="/contact">Contact</Link>
        </div>

      </div>
    </footer>
  );
};

export default Footer;